export default "__VITE_ASSET__Bsan8V45__"